/** A single description for permissions on the project level. */

/**
 * Object that determines all different permission rules for users to get
 * access on the project level.
 */

/**
 * Signature for the function hasUserValidPermissionProjectLevel.
 */

/** Names for all permissions within the project level. */
export let RequiredPermissionProjectLevelName = /*#__PURE__*/function (RequiredPermissionProjectLevelName) {
  /** Whether the user can change the role of a team member */
  RequiredPermissionProjectLevelName["canChangeRole"] = "canChangeRole";
  /** Whether the user can change the group and project manager of a project */
  RequiredPermissionProjectLevelName["canChangeProjectGroup"] = "canChangeProjectGroup";
  /** Whether the user can change the project access level of a project */
  RequiredPermissionProjectLevelName["canChangeProjectAccessLevel"] = "canChangeProjectAccessLevel";
  /** Whether the user can edit details from a project like name or description */
  RequiredPermissionProjectLevelName["canEditProjectDetails"] = "canEditProjectDetails";
  /** Whether the user can view the project cloud activity */
  RequiredPermissionProjectLevelName["canViewProjectCloudActivity"] = "canViewProjectCloudActivity";
  /**
   * Whether the user can view the members tab in project overview page
   * and view all users with access to the project
   */
  RequiredPermissionProjectLevelName["canViewAllProjectMembers"] = "canViewAllProjectMembers";
  /** Whether the user can view the project settings */
  RequiredPermissionProjectLevelName["canViewProjectSettings"] = "canViewProjectSettings";
  /** Whether the user can invite users to a private project */
  RequiredPermissionProjectLevelName["canInviteUsersToPrivateProject"] = "canInviteUsersToPrivateProject";
  /** Whether the user can invite members to a snapshot */
  RequiredPermissionProjectLevelName["canInviteMembersToSnapshot"] = "canInviteMembersToSnapshot";
  /** Whether the user can view the project activity */
  RequiredPermissionProjectLevelName["canEditProjectSettings"] = "canEditProjectSettings";
  /** Whether the user can delete a member from a project */
  RequiredPermissionProjectLevelName["canDeleteMemberFromProject"] = "canDeleteMemberFromProject";
  /** Whether the user can delete a project */
  RequiredPermissionProjectLevelName["canDeleteProject"] = "canDeleteProject";
  /** Whether the user can view the markups (annotations) of a project */
  RequiredPermissionProjectLevelName["canViewProjectMarkups"] = "canViewProjectMarkups";
  /** Whether the user can view the markups (annotations) of a project. Project viewers are allowed */
  RequiredPermissionProjectLevelName["canViewProjectMarkupsAllowViewers"] = "canViewProjectMarkupsAllowViewers";
  /** Whether the user can view the project stats chart in the project overview page */
  RequiredPermissionProjectLevelName["canViewProjectsStats"] = "canViewProjectsStats";
  /** Whether the user can edit the markup details */
  RequiredPermissionProjectLevelName["canEditProjectMarkups"] = "canEditProjectMarkups";
  /** Whether the user can view project integrations tab. */
  RequiredPermissionProjectLevelName["canViewProjectIntegrations"] = "canViewProjectIntegrations";
  return RequiredPermissionProjectLevelName;
}({});